// The one attachment constant (D7): five files and 20 MB per turn in the
// composer, media-prep, the Laravel BFF and the runtime. Derived from the
// generated MEDIA_LIMITS (contracts/copilot/media/v1/limits.json emitted into
// src/generated/copilot-contracts.ts; check-contract-drift.sh keeps them equal),
// never written by hand. App code never imports the JSON itself:
// resolveJsonModule stays off and the Docker build context is apps/web alone.
import { MEDIA_LIMITS as CONTRACT_LIMITS } from "@/generated/copilot-contracts";

export const MEDIA_LIMITS = Object.freeze({
  maxAttachments: CONTRACT_LIMITS.max_attachments,
  maxFileBytes: CONTRACT_LIMITS.max_file_bytes,
  maxTurnBytes: CONTRACT_LIMITS.max_turn_bytes,
  pdfMaxPages: CONTRACT_LIMITS.pdf_max_pages,
});

const MEBIBYTE = 1024 * 1024;

/** Whole megabytes for clinic-facing copy, rounded down so the copy never promises more than the limit. */
export function wholeMegabytes(bytes: number): number {
  return Math.floor(bytes / MEBIBYTE);
}
